import { useTranslation } from 'react-i18next'

import { TextArea } from '@reveni-io/reveni-ui'

import { literalTranslationOptions } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/TrackingPagePreview/constants'

const BlockSettingTextareaField = ({ field, value, onChange }) => {
  const { t } = useTranslation()

  const handleChange = event => onChange(field.key, event.target.value)

  return (
    <TextArea
      fullWidth
      rows={field.rows}
      label={t(field.label, literalTranslationOptions)}
      helperText={t(field.helper, literalTranslationOptions)}
      placeholder={t(field.placeholder, literalTranslationOptions)}
      value={value}
      onChange={handleChange}
    />
  )
}

export default BlockSettingTextareaField
